<template>
  <XTable :data="[1,2]">
    <template v-slot:header-row>
      <th>My Campaigns</th>
    </template>
    <template v-slot:row>
      <td class="!py-3">
        <div class="flex gap-5 relative">
          <div class="animate-pulse flex justify-center items-center">
            <div class="rounded-lg bg-base-content/10 h-16 w-32"></div>
          </div>

          <div class="flex flex-col justify-center w-full">
            <div
              class="flex h-4 w-100 items-center mb-4 animate-pulse bg-base-content/10 rounded-lg"
            ></div>

            <div
              class="flex h-1.5 w-20 items-center mb-2 animate-pulse bg-base-content/10 rounded-lg"
            ></div>

            <div
              class="flex h-6 w-20 items-center mb-2 animate-pulse bg-base-content/10 rounded-lg"
            ></div>
          </div>
        </div>
      </td> </template
  ></XTable>
</template>
